import LocationButton from "src/components/button/location-button";
import VoiceButton from "src/components/button/voice-button";
import XrayButton from "src/components/button/xRay-button";
import AnnotationButton from "src/components/button/annotation-button";
import PovButton from "../../button/pov-button";
import ImageButton from "src/components/button/image-button";
import { useNavigationStore } from "@/store/navigationStore";
import Image from "src/components/image";

export default function NavSideControl() {
  const xRayMode = useNavigationStore((state) => state.xRayMode);
  const annotationMode = useNavigationStore((state) => state.annotationMode);

  return (
    <div className="flex w-full justify-end p-[20px] pb-[30px]">
      <div className="flex flex-col gap-4">
        
        <PovButton />
        <LocationButton />
        <VoiceButton />
        <span className={`${xRayMode == 0 ? 'pointer-events-none opacity-[0.4]':''}`}>
          <XrayButton mode={"navigation"} />
        </span>
        <span className={`${annotationMode == 0 ? 'pointer-events-none opacity-[0.4]':''}`}>
          <AnnotationButton mode={"navigation"}/>
        </span>
      </div>
    </div>
  );
}